
Vue.component("keyword_analysis", {
  data() {
    return {
      show: true,
      ifMore: false,
      moreActive: false,
      content: ''
    }
  },
  mounted() {
  },
  watch: {
    word: {
      handler: function (newVal) {
        newVal && this.init()
      },
      immediate: true
    }
  },
  directives: {
    keyword: {
      update: (el, binding, node) => {
        // 聚焦元素
        let txt = el.innerHTML
        if (!binding.value || !txt) return
        const match = binding.value
        let str = ''
        if (txt) {
          str = txt.replace(match, (item) => {
            return `<span style="color:var(--color-primary);font-size: 18px;font-weight: 600">${item}</span>`
          })
        }
        el.innerHTML = str
      }
    },
  },
  props: {
    word: '',
  },
  methods: {
    init() {
      const that = this
      API.reqKeywordChatGlm(this.word).then(res => {
        if (!res.success) return
        that.content = (res.data || '').replaceAll('\\\\n', '')
        if(!that.content) {
          //无解析不显示
          that.show = false
          return
        }
        that.$nextTick(() => {
          let ifEllipsis = that.getIfEllipsis()
          if (ifEllipsis) {
            that.ifMore = true
          }
        })
      })
    },
    getIfEllipsis() {
      const box = document.querySelectorAll('.keyword_analysis_box .content')[0]
      const range = document.createRange();
      range.setStart(box, 0)
      range.setEnd(box, 1)
      let rangeHeight = range.getBoundingClientRect().height
      if (rangeHeight > box.clientHeight) {
        //存在省略号
        return true
      } else {
        return false
      }
    }
  },
  template: `
  <div class="keyword_analysis_box" v-show="show">
    <div class="content" :style="{display: moreActive?'block':'-webkit-box'}" v-keyword="word">{{content}}</div>
    <span class="more_btn" v-show="ifMore && !moreActive" @click="moreActive = true">{{$t('展开词条')}}∨</span><span class="more_btn" v-show="ifMore && moreActive" @click="moreActive = false">{{$t('收起词条')}}∧</span>
  </div>
  `,
});